module.exports = __webpack_public_path__ + "static/media/bill-id.9614c581.png";